/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MusicbrainzTrack
 */
export interface MusicbrainzTrack {
    /**
     * 
     * @type {string}
     * @memberof MusicbrainzTrack
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MusicbrainzTrack
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof MusicbrainzTrack
     */
    artist?: string;
    /**
     * 
     * @type {number}
     * @memberof MusicbrainzTrack
     */
    position: number;
    /**
     * 
     * @type {number}
     * @memberof MusicbrainzTrack
     */
    length: number;
}

/**
 * Check if a given object implements the MusicbrainzTrack interface.
 */
export function instanceOfMusicbrainzTrack(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "position" in value;
    isInstance = isInstance && "length" in value;

    return isInstance;
}

export function MusicbrainzTrackFromJSON(json: any): MusicbrainzTrack {
    return MusicbrainzTrackFromJSONTyped(json, false);
}

export function MusicbrainzTrackFromJSONTyped(json: any, ignoreDiscriminator: boolean): MusicbrainzTrack {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'artist': !exists(json, 'artist') ? undefined : json['artist'],
        'position': json['position'],
        'length': json['length'],
    };
}

export function MusicbrainzTrackToJSON(value?: MusicbrainzTrack | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'artist': value.artist,
        'position': value.position,
        'length': value.length,
    };
}

